import a from "./ScalarTabs.vue2.js";
import o from "../../../../_virtual/_plugin-vue_export-helper.js";
const t = /* @__PURE__ */ o(a, [["__scopeId", "data-v-171fab0f"]]);
export {
  t as default
};
